module.exports = __webpack_public_path__ + "static/media/bebe.44ca63c8.png";